import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    api, getEventById, getEventInfosByEventId, getTicketTypesByEventId, getTicketTypeInfosByTicketTypeId,
    getTicketTypeNumberOfAvailableTickets
} from "ticketino-api-client";

import "../css/style.css";
import Header from "./components/Header";
import Loading from "./components/Loading";


const Step20_Tickets = () => {
    const [event, setEvent] = useState([]);
    const [ticketTypes, setTicketTypes] = useState([]);
    const [selectedTicketTypes] = useState([]);
    const [disabled, setDisabled] = useState(true);
    const [orderId] = useState(sessionStorage.getItem("orderId"));
    const [token] = useState(sessionStorage.getItem("token"));
    const [moreInfo, setMoreInfo] = useState({});
    const [loading, setLoading] = useState(true);
    const [quantity, setQuantity] = useState(0);

    const [error, setError] = useState("");

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching params
    const { language } = useParams();
    const { eventId } = useParams();
    const { timeSlotId } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        case ("it" || "IT"):
            languageId = 4;
            break;
        default:
            languageId = 0;
            break;
    }

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;

        if (orderId) {
            loadEvent(eventId, orderId)
        }
    }, [orderId]); //gets called when an order is started

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadEvent = async (eventId, orderId) => {
        try {
            setLoading(true);

            // Event
            const event = await getEventById(eventId);
            const infos = await getEventInfosByEventId(eventId);

            // sorting it according to the language
            const eventInfo = infos.eventInfos.find(info => info.languageId == languageId);

            const timeSlots = await requestTimeSlotsForEvent(eventId);

            const currTimeSlot = timeSlots.find(ts => ts.timeSlotId == timeSlotId);

            // setting the eventInfo object in the info attribute of event
            const updatedEventInfo = { ...event, info: eventInfo, timeSlot: currTimeSlot };

            // TicketType
            const ticketTypes = await getTicketTypesByEventId(eventId);

            const updatedTicketTypes = await Promise.all(
                ticketTypes.map(async (ticketType) => {
                    const info = await getTicketTypeInfosByTicketTypeId(ticketType.id);

                    // sorting it according to the language
                    const ticketTypeInfo = info.find(info => info.languageId == languageId);

                    const ticketTypeAvailability = await getTicketTypeNumberOfAvailableTickets(ticketType.id, orderId);

                    // setting the ticketTypeInfo and ticketTypeAvailability object as attributes in ticketType (info and availability)
                    return { ...ticketType, info: ticketTypeInfo, availability: ticketTypeAvailability }
                })
            )

            // setting the values in the end
            setEvent(updatedEventInfo);
            setTicketTypes(updatedTicketTypes);
            setLoading(false);

        } catch (error) {
            setLoading(false);
            console.error(error);
        }
    }

    const requestTimeSlotsForEvent = async (id) => {
        try {
            const res = await axios.get(`${baseUrl}/Event/${id}/TimeSlots`);
            return res.data;
        } catch (error) {
            console.error(error);
        }
    }


    const addTicketToBasket = async () => {
        let addTicketTypes = [];

        let updatedTickets = selectedTicketTypes;

        updatedTickets.map((t) => {
            if (t.quantity !== "0") {
                t.timOfEntryFrom = event?.timeSlot?.beginTime;
                t.timOfEntryTo = event?.timeSlot?.endTime;
                addTicketTypes.push(t);
            }
        })

        await axios
            .post(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                ticketsToAdd: addTicketTypes,
            })
            .then(() => {
                navigate(`/${language}/shipping`);
            })
            .catch((error) => {
                setError(error.response.data);
                console.error(error.response.data);
            });
    };

    const onSubmit = async () => {
        await addTicketToBasket();
    };

    const onTicketTypeChange = (e, ticketTypeId) => {

        let totalAvailableTickets = event?.timeSlot?.totalAvailableTickets - event?.timeSlot?.totalTicketsSold;

        const obj = {
            ticketTypeId: ticketTypeId,
            quantity: e.target.value,
        };

        const existingTicketType = selectedTicketTypes.find(
            (t) => t.ticketTypeId === ticketTypeId
        );

        if (existingTicketType) {
            existingTicketType.quantity = e.target.value;
        } else {
            selectedTicketTypes.push(obj);
        }

        // calcualate quantity and validate
        let qty = 0;

        selectedTicketTypes.map(s => {
            qty += s.quantity * 1;
        });

        setQuantity(qty);

        if (qty > 0) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }

        if (qty > totalAvailableTickets) {
            setDisabled(true);
        }
    };

    const textContainer = () => {
        let eventStart = "";

        if (event.start) {
            const options = { day: '2-digit', month: 'long', year: 'numeric' };
            eventStart = new Date(event?.start).toLocaleDateString(`de`, options);
        }

        let beginTime = "";
        let endTime = "";

        if (event.timeSlot) {
            beginTime = event.timeSlot?.beginTime.slice(0, 5);
            endTime = event.timeSlot?.endTime.slice(0, 5);
        }

        return (
            <div className="fs-6 text-container mb-3 row">
                <div className="col-md-6 col-12 text-start">{resources.BuyTickets}</div>
                <div className="col-md-6 col-12 text-end fs-6 event-start">{eventStart}, {beginTime} - {endTime}</div>
            </div>
        )
    }

    const mapTicketTypes = () => {
        let ticketTypesSorted = [];

        if (ticketTypes && ticketTypes.length > 0) {
            ticketTypesSorted = [...ticketTypes].sort((a, b) => a.sortOrder - b.sortOrder);
        }

        return (
            ticketTypes &&
            ticketTypes.length > 0 &&
            ticketTypesSorted.map((tt, index) => {

                let contingent = tt.maxNumberOfTicketsPerOrder;
                let totalTicketsLeft = event?.timeSlot?.totalAvailableTickets;
                if (totalTicketsLeft < contingent) contingent = totalTicketsLeft;

                let timeSlotOfTicketType = event?.timeSlot?.ticketTypes?.find(tts => tts.item1 == tt.id);

                let ticketsLeftOfTicketType = 0;

                if (timeSlotOfTicketType) {
                    ticketsLeftOfTicketType = timeSlotOfTicketType.item2;
                }

                return (
                    <div key={index}>
                        {
                            (tt.availability?.status === 0 && event?.timeSlot?.ticketTypeIds?.includes(tt.id)) &&
                            (
                                <div className={"row pt-2 pb-2 " + (ticketsLeftOfTicketType <= 0 ? "ticket-disabled" : "") }>
                                    <div className="col-md-8 col-6">
                                        <label className="fs-6">
                                            {tt.info?.name}
                                        </label>
                                        {/* <div className="description">
                                        <span onClick={() => setMoreInfo({ [tt.id]: !moreInfo[tt.id] })}>{resources.OtherInfos} <i class={"bi bi-chevron-" + (moreInfo[tt.id] ? "down" : "up")}></i></span><br></br>
                                        {moreInfo[tt.id] && tt.info?.description}
                                    </div> */}
                                    </div>
                                    <div className="col-md-2 col-3 text-center">
                                        <label>
                                            {tt.currency} {tt.price}.-
                                        </label>
                                    </div>
                                    <div className="col-md-2 col-3">
                                        <select
                                            className="form-select"
                                            onChange={(e) => onTicketTypeChange(e, tt.id)}
                                        >
                                            {Array.from(
                                                Array(
                                                    (contingent) + 1
                                                ),
                                                (e, i) => {
                                                    return (
                                                        <option key={i} value={i}>
                                                            {i}
                                                        </option>
                                                    );
                                                }
                                            )}
                                        </select>
                                    </div>
                                </div>
                            )}
                    </div>
                )
            })
        );
    };
    return (
        <div className="container wrapper">
            <Header showText={true} resources={resources} />
            <div className="mt-4">
                <div>
                    <div className="container">
                        {textContainer()}
                    </div>
                    <div>
                        {!loading ? <>
                            {mapTicketTypes()}
                            <p className="fs-6 mt-2 text-green">{((event?.timeSlot?.totalAvailableTickets - event?.timeSlot?.totalTicketsSold) - quantity)} {(((event?.timeSlot?.totalAvailableTickets - event?.timeSlot?.totalTicketsSold) - quantity) == 1) ? resources.FreeTrain : resources.FreeTrains}</p>
                        </> : <Loading bgColor="#fff" color="#c4daee" />}
                    </div>
                </div>
                <div>
                    <p className="fs-6 text-danger">{error}</p>
                </div>
                <div className="row mt-4 mb-4">
                    <div className=" col-6 text-start">
                        <button className="button" onClick={() => navigate(-1)}>
                            {resources.Back}
                        </button>
                    </div>
                    <div className="col-6 text-end">
                        <button className="button" disabled={disabled} onClick={() => onSubmit()}>
                            {resources.Next}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Step20_Tickets